export default __webpack_public_path__ + "static/media/Vazir-Light.04e16402.woff2";